import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "A apărut o eroare. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const IMG_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3C/svg%3E";

export function resolveImage(img) {
  if (!img) return IMG_PLACEHOLDER;
  if (img.startsWith("http")) return img;
  if (img.startsWith("/")) return img;
  return `${API}/files/${img}`;
}

export function formatPrice(value) {
  return new Intl.NumberFormat("ro-RO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0) + " lei";
}

export const SHOP_PHONE = "0750295264";
export const SHOP_WHATSAPP = "40750295264";

export function whatsappLink(product) {
  const text = product
    ? `Bună! Vreau să comand: ${product.name} - ${formatPrice(product.price)}`
    : "Bună! Vreau să plasez o comandă ClarWash.";
  return `https://wa.me/${SHOP_WHATSAPP}?text=${encodeURIComponent(text)}`;
}

export function phoneLink() {
  return `tel:+4${SHOP_PHONE}`;
}

export function sortOffersFirst(products) {
  const hasOffer = (p) => (p.old_price && p.old_price > p.price ? 1 : 0);
  return [...products].sort((a, b) => {
    const prio = (b.priority || 0) - (a.priority || 0);
    if (prio !== 0) return prio;
    const off = hasOffer(b) - hasOffer(a);
    if (off !== 0) return off;
    return (b.price || 0) - (a.price || 0);
  });
}

export default api;
